import { Vue, Component } from 'vue-property-decorator'
import s from '~/utils/s'

@Component
export default class DiseasesHeader extends Vue {
  openPopup (e: MouseEvent) {
    e.stopPropagation()
    s(this.$store).general.openPopup('DiseasesSectionsPopup')
  }

  mounted () {
    window.addEventListener('resize', this.resize)
  }

  resize () {
    const width = window.innerWidth
    if (s(this.$store).general.popupName === 'DiseasesSectionsPopup' && width >= 768) {
      s(this.$store).general.closePopup()
    }
  }

  render () {
    return (
      <div class="diseases-header">
        <div class="diseases-header__content">
          <h1 class="diseases-header__content-header">
            Справочник заболеваний
          </h1>
          <div class="diseases-header__btn" onClick={this.openPopup}>
            Разделы медицины
          </div>
        </div>
      </div>
    )
  }
}
